<template>
    <div class="m-m">
        <h1>LUMI-O Credentials Management Service</h1>
        <p>Unfortunately your CSC account appears to be locked. Please contact your <a href="https://lumi-supercomputer.eu/user-support/need-help/">LUMI user support</a></p>
    </div>
</template>

<script>
export default {
    name: "LoginLocked",
}
</script>